import { Link, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { RiDeleteBin2Fill } from "react-icons/ri";
import { ArchivedStatusIcon } from "../../assets/icons/ArchivedStatusIcon";
import { CheckStatusIcon } from "../../assets/icons/CheckStatusIcon";
import { DraftStatusIcon } from "../../assets/icons/DraftStatusIcon";
import { SignedStatusIcon } from "../../assets/icons/SignedStatusIcon";
import { WorkFlowStatusIcon } from "../../assets/icons/WorkFlowStatusIcon";
import { ItemValidationRule } from "../../model/ItemModel";
import { UseStatus, UseStatusWithCurrentOperation } from "./hooks/useStatus";
import { NoStatus } from "../../assets/icons/NosStatus";

const statusStyle = {
    '&:hover': {
        cursor: 'pointer'
    }

}

interface IStatus {
    onClick?: () => void;
    release: boolean;
    validationObject: ItemValidationRule | undefined;
    type: string;
    batchWaiter?: boolean;
    archiving?:boolean;
    expired?:boolean;
    draft?: boolean;
    d4Signed?: boolean;
}

const Status: React.ForwardRefExoticComponent<IStatus> = React.forwardRef(({
    onClick,
    release,
    type,
    validationObject,
    batchWaiter,
    archiving,
    expired,
    draft,
    d4Signed
}, ref) => {

    const { t } = useTranslation();

    const currentStatus = UseStatus(release,validationObject, type, batchWaiter,archiving, expired, d4Signed, t);

    const currentOperation = UseStatusWithCurrentOperation(release, validationObject, type, batchWaiter, archiving, expired, d4Signed).currentOperation;

    function tooltipTitleRender(): string {
        return currentOperation !== undefined ? `${currentStatus}` : currentStatus
    }

    function returnStatusIcon () {
        switch (currentStatus) {
            case "Filed": 
                return <ArchivedStatusIcon />
            case "Release":
                return <CheckStatusIcon />
            case "Flow":
                return <WorkFlowStatusIcon />
            case "Draft":
                return <DraftStatusIcon />
            case "Removido":
                return <RiDeleteBin2Fill />
            case "Signed":
                return <SignedStatusIcon />
            default:
                return <NoStatus/>
        }
    }

    return (
        <Link
            onClick={type !== 'folder' ? onClick : undefined}
            underline="none"
            sx={statusStyle}
        >
            <Tooltip title={tooltipTitleRender()}>
                <span style={{display: 'flex', justifyContent:'center', alignItems:'center', height: '100%'}}>
                {returnStatusIcon()}
                </span>
            </Tooltip>
        </Link>
    )
});

export default Status;